import { Component, inject, signal } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PasswordRecoveryDialog } from '../password-recovery.dialog';
import { SocialLoginButtonsComponent } from '../social-login-buttons.component';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, MatIconModule, RouterModule, MatProgressSpinnerModule, MatCheckboxModule, MatDialogModule, PasswordRecoveryDialog, SocialLoginButtonsComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  error = signal<string>('');
  loading = signal(false);
  private dialog = inject(MatDialog);

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    recordarSesion: [true]
  });

  constructor(private authService: AuthService, private router: Router, private fb: FormBuilder) { }

  login(email: string, password: string, recordarSesion: boolean) {
    this.loading.set(true);
    this.authService.login(email, password, recordarSesion)
      .then((user) => {
        this.authService.sincronizarUsuario(user.user, {});
        const lastUrl = localStorage.getItem('lastVisitedUrl');
        this.router.navigateByUrl(lastUrl || '/');
      })
      .catch(err => this.error.set(this.traducirError(err.code) || err.message))
      .finally(() => this.loading.set(false));
  }

  abrirDialogRecuperacion() {
    this.dialog.open(PasswordRecoveryDialog);
  }

  /*
  enviarRecuperacion() {
    this.authService.enviarRecuperacion(this.recuperacionEmail)
      .then(() => this.recuperacionMensaje = 'Se envió un email para restablecer la contraseña.')
      .catch(err => this.recuperacionMensaje = err.message);
  }
  */

  onSubmit() {
    if (this.form.invalid) return;
    this.loading.set(true);
    this.error.set('');

    const { email, password, recordarSesion } = this.form.value;

    this.login(email!, password!, recordarSesion!);

  }

  loginWithGoogle() {
    this.loading.set(true);
    this.authService.loginWithGoogle()
      .then((user) => {
        this.authService.sincronizarUsuario(user.user, {});
        const lastUrl = localStorage.getItem('lastVisitedUrl');
        this.router.navigateByUrl(lastUrl || '/');
      })
      .catch(err => this.error.set(this.traducirError(err.code)))
      .finally(() => this.loading.set(false));
  }

  loginWithFacebook() {
    this.loading.set(true);
    this.authService.loginWithFacebook()
      .then((user) => {
        this.authService.sincronizarUsuario(user.user, {});
        const lastUrl = localStorage.getItem('lastVisitedUrl');
        this.router.navigateByUrl(lastUrl || '/');
      })
      .catch(err => this.error.set(this.traducirError(err.code)))
      .finally(() => this.loading.set(false));
  }

  traducirError(code: string): string {
    switch (code) {
      case 'auth/invalid-email':
        return 'El email ingresado no es válido.';
      case 'auth/user-not-found':
        return 'No existe una cuenta con ese email.';
      case 'auth/popup-closed-by-user':
        return 'El inicio fue cancelado.';
      case 'auth/account-exists-with-different-credential':
        return 'Ya existe una cuenta con ese email usando otro método.';
      case 'auth/invalid-credential':
        return 'El email o la contraseña son incorrectos.';
      case 'auth/invalid-verification-code':
        return 'El código de verificación no es válido.';
      case 'auth/invalid-verification-id':
        return 'El ID de verificación no es válido.';
      case 'auth/invalid-phone-number':
      default:
        return 'Ocurrió un error. Intentá nuevamente.';
    }
  }

  onLoginExitoso() {
    const lastUrl = localStorage.getItem('lastVisitedUrl');
    this.router.navigateByUrl(lastUrl || '/');
  }

}
